import { z } from 'zod';

export const GetDepartmentsVariablesSchema = z.object({
  input: z.object({
    accountId: z.string().uuid(),
  }),
});

export const GetTemplatesVariablesSchema = z.object({
  input: z.object({
    accountId: z.string().uuid(),
    parentType: z.string().optional(),
    parentId: z.string().uuid().optional(),
  }),
  parentType: z.string().optional(),
  parentId: z.string().uuid().optional(),
});

export const UpdateBPFVariablesSchema = z.object({
  input: z.object({
    parentType: z.string(),
    flowId: z.string().uuid(),
    nextStage: z.string().uuid(),
    parentId: z.string().uuid(),
  }),
});

export const SetTemplateActiveStatusVariablesSchema = z.object({
  input: z.object({
    flowId: z.string().uuid(),
    departmentId: z.string().uuid(),
  }),
});

export const SetTemplateActiveStatusResponseSchema = z.object({
  result: z.object({
    success: z.boolean(),
    error: z.string().nullable(),
    entity: z.any().nullable(),
  }),
});
